<!--
  回款计划里的回款状态
  prop:
    item: 绑定对象
    form: form表单数据对象
 -->

<template>
  <div class="payment-status">
    <el-select
      filterable
      :disabled="item.nonEditable"
      v-if="item.valueArrMap"
      v-model="form[item.attr]"
      :placeholder="item.placeholder"
      >
      <el-option
        v-for="arr in item.valueArrMap"
        :key="arr.key"
        :label="arr.value"
        :value="arr.key">
      </el-option>
    </el-select>
    <!-- 创建人 -->
    <template v-if="form[item.attr] === '2' && item.isBelonger">
      <div class="manager">
        <label class="el-form-item__label">归属人</label>
        <v-manager
          :item="belongerItem"
          :form="form">
        </v-manager>
      </div>
      <div class="manager">
        <label class="el-form-item__label">支付方式</label>
        <el-select
          filterable
          :disabled="item.nonEditable"
          v-model="form.payMethod"
          placeholder="请选择"
          >
          <el-option
            v-for="arr in payMethodArray"
            :key="arr.key"
            :label="arr.value"
            :value="arr.key">
          </el-option>
        </el-select>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import vManager from '../manager'

export default {
  props: {
    item: {
      type: Object,
      default: {}
    },
    form: {
      type: Object,
      default: {}
    },
    payMethodArray: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      belongerItem: {}
    }
  },
  created () {
    this.belongerItem = {
      attr: 'belonger',
      attrValue: this.item.extraAttrValue
    }
    Vue.set(this.form, 'payMethod', this.payMethodArray.length ? this.payMethodArray[0].key : '')
    this.form.belonger = [this.item.extraAttrValue]
  },
  methods: {
  },
  components: {
    vManager
  }
}
</script>
<style lang="less" scoped>
.payment-status {
  .manager {
    position: relative;
    margin-top: 18px;
    .el-form-item__label {
      position: absolute;
      width: 100px;
      left: -110px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// payment-status.vue?0ff55db6